module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-app', [_c('v-content', [_c('v-container', [_c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.results,
      "pagination": _vm.pagination,
      "total-items": _vm.totalResults,
      "loading": _vm.loading
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.makerUsername))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.uploadedFileName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.processingResultFileName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.createdAt))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.uploadedAt))]), _vm._v(" "), _c('td', {
          staticClass: "justify-center layout px-0"
        }, [_c('v-btn', {
          staticClass: "mr-2",
          attrs: {
            "primary": ""
          },
          on: {
            "click": function($event) {
              return _vm.downloadItem(props.item)
            }
          }
        }, [_vm._v("\n                Download\n              ")])], 1)]
      }
    }])
  }, [_vm._v(" "), _c('template', {
    slot: "no-data"
  }, [_c('p', [_vm._v(" No data Found ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.getDataFromApi
    }
  }, [_vm._v("Reload")])], 1)], 2)], 1)], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f7b27d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/file/originatorprocessingresults.vue
// module id = 1066
// module chunks = 2